import { getSessionId } from '@/lib/utils';
import type { CartItem, CartState } from '@eventflow/shared-types';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: CartState = {
  items: [],
  subtotal: 0,
  total: 0,
  sessionId: getSessionId(),
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action: PayloadAction<CartItem>) => {
      // Verificar si el asiento ya está en el carrito
      const exists = state.items.some((item) => item.seatId === action.payload.seatId);
      if (!exists) {
        state.items.push(action.payload);
        cartSlice.caseReducers.calculateTotals(state);
      }
    },

    removeFromCart: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((item) => item.seatId !== action.payload);
      cartSlice.caseReducers.calculateTotals(state);
    },

    clearCart: (state) => {
      state.items = [];
      state.subtotal = 0;
      state.total = 0;
    },

    calculateTotals: (state) => {
      state.subtotal = state.items.reduce((sum, item) => sum + item.price, 0);
      // Por ahora, total = subtotal (sin impuestos ni fees)
      state.total = state.subtotal;
    },

    setSessionId: (state, action: PayloadAction<string>) => {
      state.sessionId = action.payload;
    },
  },
});

export const { addToCart, removeFromCart, clearCart, setSessionId } = cartSlice.actions;
export default cartSlice.reducer;
